import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getLabel } from '../../language'
import "../Settings/Setting.css"
import {message} from "antd";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import Input from "antd/lib/input";
import { DatePicker, Space } from 'antd';
const {TextArea} = Input;

message.config({top:50})

const mapStateToProps = state => ({
    currentUser: state.common.currentUser,
    anonymousMode: state.user.anonymousMode
});

const PollyEditModal = props => {
    const [data,setData] = useState({})

    const handleData = (e) =>{
        const {name,value} = e.target
        if(name === "bio"){
            const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;

            const links = value.match(urlRegex)
            if(links !== null){
               const datas = value.replace(links[0],'')
                setData({...data,[name]:datas})
            }else{
                setData({...data,[name]:value})
            }
        }else
        setData({...data,[name]:value})
    }

    const onChangeDate = (date, dateString) => {
        setData({...data,['dateOfBirth']:dateString})
    }

    return (
        <Modal className={`privacy-header ${props.anonymousMode ? "dark" : ""}`} show={props.state.pollyEditModal} onHide={props.pollyEditModal}>
            <Modal.Header>
                <Modal.Title>
                    {getLabel(130)}
                </Modal.Title>
                <button type="button" className="close" data-dismiss="modal" onClick={props.pollyEditCancel} aria-hidden={props.state.pollyEditModal}>×</button>
            </Modal.Header>
            <Modal.Body>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Contact Form :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="contactForm"
                        value={data.contactForm || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Date of Birth :</label>
                    <span className="col-md-7 p-l-20">
                    <Space direction="vertical">
                        <DatePicker onChange={onChangeDate} />
                    </Space>
                    </span>
                    {/*<input*/}
                    {/*    className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}*/}
                    {/*    type="text"*/}
                    {/*    name="dateOfBirth"*/}
                    {/*    value={data.dateOfBirth || ''}*/}
                    {/*    onChange={(e) => handleData(e)}*/}
                    {/*    placeholder={getLabel(304)}*/}
                    {/*/>*/}
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">FacebookId :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="facebookId"
                        value={data.facebookId || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">FacebookPage :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="facebookPage"
                        value={data.facebookPage || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Gender :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="gender"
                        value={data.gender || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">GovTrackID :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="govTrackId"
                        value={data.govTrackId || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Twitter :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="twitter"
                        value={data.twitter || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">VoteSmartId :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="voteSmartId"
                        value={data.voteSmartId || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Website :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="webSite"
                        value={data.webSite || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">WikipediaId :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="wikiPediaId"
                        value={data.wikiPediaId || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Youtube :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="youTube"
                        value={data.youTube || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">YoutubeId :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="youTubeId"
                        value={data.youTubeId || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">Bio :</label>
                    <TextArea
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        placeholder={getLabel(304)}
                        maxLength={400}
                        name="bio"
                        value={data.bio || ''}
                        onChange={(e) => handleData(e)}
                    />
                </div>
                <div className={`custom-gender ${props.anonymousMode ? "cw" : ""} m-b-10`}>
                    <label className="col-md-4">EmailAddress :</label>
                    <input
                        className={`form-control${props.anonymousMode ? "-dark cw" : ""} form-control-lg custom-gender-child col-md-7`}
                        type="text"
                        name="emailAddress"
                        value={data.emailAddress || ''}
                        onChange={(e) => handleData(e)}
                        placeholder={getLabel(304)}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.pollyEditCancel} className={`m-t-30 btn-primary${props.anonymousMode ? "-dark" : " custom-dp"}`}>{getLabel(80)}</Button>
                <Button onClick={props.pollyEditCancel} className={`m-t-30 btn-primary${props.anonymousMode ? "-dark" : " custom-dp"}`}>{getLabel(106)}</Button>
            </Modal.Footer>
        </Modal>
    )

};
export default withRouter(connect(mapStateToProps)(PollyEditModal));

